export class HTTPServerError extends Error {
  /** 兼容旧字段命名 */
  traceID: string;
  /** 与新版 HTTP client 命名保持一致，便于上层统一读取 */
  traceId: string;

  constructor(message: string, traceID: string) {
    super(message);
    this.name = "HTTPServerError";
    this.traceID = traceID || "";
    this.traceId = traceID || "";
  }
}
